import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomerIoSessionTracker } from '../customer-io';
import { RudderstackSessionTracker } from '../rudderstack';
export var ObservabilitySessionTrackers = function () { return (_jsxs(_Fragment, { children: [_jsx(CustomerIoSessionTracker, {}), _jsx(RudderstackSessionTracker, {})] })); };
